"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadETRF = exports.getETRFDetails = exports.getETRFList = void 0;
var react_hot_toast_1 = require("react-hot-toast");
var api_service_1 = require("../../../api/api_service");
var getETRFList = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .get({
            endPoint: "".concat(api_service_1.api_service.api_urls.ETRF_UPDATED_LIST, "?").concat(payload),
            domain: process.env.SAMPLE_TRAKING_URL
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                return resolve(res.data);
            }
            var erroMessage = res.data
                ? res.data.message
                : 'Unable to process your request.';
            throw new Error(erroMessage);
        })
            .catch(function (e) {
            return reject(e);
        });
    });
};
exports.getETRFList = getETRFList;
var getETRFDetails = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.ETRF_DETAILS,
            domain: process.env.SAMPLE_TRAKING_URL,
            payLoad: payload,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                return resolve(res.data);
            }
            var erroMessage = res.data
                ? res.data.message
                : 'Unable to process your request.';
            throw new Error(erroMessage);
        })
            .catch(function (e) {
            return reject(e);
        });
    });
};
exports.getETRFDetails = getETRFDetails;
var downloadETRF = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.ETRF_GENERATE,
            payLoad: payload,
            domain: process.env.SAMPLE_TRAKING_URL,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                return resolve(res.data);
            }
            else {
                react_hot_toast_1.default.error(res.data.message);
            }
        })
            .catch(function (e) {
            return reject(e);
        });
    });
};
exports.downloadETRF = downloadETRF;
